export const WS_BROWN = "#604020";
export const WS_CREAM = "#fff8ed";
export const WS_DARK_CREAM = "#f5eee2";
export const WS_GREEN = "#008400";
export const WS_RED = "#c40020";
